import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("masala_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("masala_cookie_consent", JSON.stringify({
      necessary: true,
      analytics: true,
      accepted_at: new Date().toISOString()
    }));
    setVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem("masala_cookie_consent", JSON.stringify({
      necessary: true,
      analytics: false,
      accepted_at: new Date().toISOString()
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6"
      data-testid="cookie-consent-banner"
    >
      <div
        className="max-w-4xl mx-auto rounded-2xl shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        style={{
          background: 'linear-gradient(135deg, #2d1810 0%, #1a0f0a 100%)',
          border: '2px solid #d4af37'
        }}
      >
        <Cookie className="h-8 w-8 flex-shrink-0" style={{ color: '#d4af37' }} />
        <div className="flex-1">
          <p className="text-sm sm:text-base font-medium" style={{ color: '#f5e6d3' }}>
            Vi bruker informasjonskapsler (cookies) for at nettsiden skal fungere best mulig.
          </p>
          <a
            href="/personvern"
            className="text-xs sm:text-sm underline mt-1 inline-block"
            style={{ color: '#d4af37' }}
          >
            Les var personvernerklaering
          </a>
        </div>
        <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
          <button
            onClick={acceptNecessary}
            className="flex-1 sm:flex-initial px-4 py-2 rounded-lg text-sm font-medium transition-colors"
            style={{
              background: 'transparent',
              border: '1px solid #d4af37',
              color: '#d4af37'
            }}
            data-testid="cookie-accept-necessary"
          >
            Kun nodvendige
          </button>
          <button
            onClick={acceptAll}
            className="flex-1 sm:flex-initial px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
            style={{
              background: '#d4af37',
              color: '#2d1810'
            }}
            data-testid="cookie-accept-all"
          >
            Godta alle
          </button>
        </div>
        <button
          onClick={acceptNecessary}
          className="absolute top-3 right-3 sm:static"
          style={{ color: '#d4af37' }}
          data-testid="cookie-close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
